module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Нанимайте прямо из ваших аккаунтов в социальных сетях"}}')
  delete Component.options._Ctor
}
